import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import * as dayjs from 'dayjs';

//https://stackblitz.com/edit/swiper-angular-example?file=src%2Fapp%2Fapp.component.html
import SwiperCore, {
	Navigation,
	Pagination,
	//Scrollbar,
	A11y,
	Lazy
} from 'swiper/core';


SwiperCore.use([
	Navigation,
	Pagination,
	//Scrollbar,
	A11y,
	Lazy
	// Virtual,
	// Zoom,
	// Autoplay,
	// Thumbs,
	// Controller
]);

import { TabGroupController } from 'ascedia-design-system/lib/models/tab-group-controller.interface';


//SERVICES
import { CompassAPIDestinationsService } from 'src/app/shared/api-compass/compass-api-destinations.service';
import { CompassAPIDynamicListService } from 'src/app/shared/api-compass/compass-api-dynamic-list.service';
import { CompassAPIRegionsService } from 'src/app/shared/api-compass/compass-api-regions.service';
import { ConfigService } from '../../shared/services/config.service';
import { MockAPIProvider } from 'src/app/shared/services/mock-api.provider';
import { StorageService } from 'src/app/shared/services/storage.service';
import { CompassAPICruiseSearchService } from 'src/app/shared/api-compass/compass-api-cruise-search.service';
import { MetaService } from 'src/app/shared/services/meta.service';

//MODELS
import { Breakpoint } from 'ascedia-design-system/lib/models/breakpoint.enum';
import { Destination } from 'src/app/shared/models/destination.interface';
import { DynamicList } from 'src/app/shared/models/dynamic-list.interface';
import { InfoBox } from 'ascedia-design-system/lib/models/info-box.interface';
import { ImageGridItem } from 'ascedia-design-system/lib/models/image-grid-item.interface';
import { SwiperCardImage } from 'ascedia-design-system/lib/models/swiper-card-image.interface';
import { Region } from 'src/app/shared/models/region.interface';
//import { Window } from 'ascedia-design-system/lib/models/window.interface';
import { DynamicListDisplay } from 'src/app/shared/models/dynamic-list-display.interface';
import { CruiseLine } from 'src/app/shared/models/cruise-line.interface';
import { CruiseLineSailDate } from 'src/app/shared/models/cruise-line-sail-date.interface';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { CartTest } from 'src/app/shared/models/cart-test.interface';






@Component({
	selector: 'app-home',
	templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

	public listTypes: any[] = [
		{
			id: 'DESTINATION',
			name: 'Destination'
		},
		{
			id: 'PRODUCT',
			name: 'Excursion'
		},
		{
			id: 'REGION',
			name: 'Region'
		}
	];

	public favsList: any[];

	public intDest;

	public test1 = 'asdf **asdf** asdf';
	public test = `If you’re looking for a day of history and culture, this is the tour for you. Immerse yourself in a journey from the past at the **Chacchoben Ruins** to the world of present-day Maya descendants at the Chacchoben Village.

	Start your journey in an air-conditioned ride to the ruins, which takes about 50 minutes.  Upon arrival, your expert guide will share the Maya settlement’s history which flourished as early as 300 AD. Learn about the secrets of this ceremonial center during the approximately 90-minute walking tour. Take in the sites of the surrounding jungle and perhaps climb the Gran Basamento, Chacchoben's ritual heart. Hard to believe, but the Chacchoben Ruins have only been open to the public since 2002.

	Fast forward to daily life and celebrate the colorful culture of the modern Maya. Learn the secrets behind the perfect tortilla in a one-on-one tortilla lesson and learn about traditional home remedies. Local family hosts are eager to serve you a tasty lunch cooked with authentic spices and fresh ingredients.  Expect a meal beyond the typical tourist food and savor the authentic flavors of the Yucatan.`;

	public options = {
		showBorder: false
	  }

	public cruiseLineId: string = '';
	public cruiseLineShipName: string = '';
	public codeToCruiseId: string = '';
	public cruiseLineShipSailDate: CruiseLineSailDate = {};

	public sectionActive: number = 0;

	public breakpoints = {
		//lowest setting is in markup
		640: { slidesPerView: 2.25, slidesPerGroup: 2, spaceBetween: 10 },
		991: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 20 }
	};

	public breakpointsBg = {
		//lowest setting is in markup
		575: { slidesPerView: 2.25, slidesPerGroup: 2, spaceBetween: 10 },
		640: { slidesPerView: 3.25, slidesPerGroup: 3, spaceBetween: 15 },
		991: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 20 }
	};


	public tabListSearch: TabGroupController[] = [
		{
			title: 'Search by Cruise Line',
			id: 0,
			isActive: false,
			icon: 'circle',
			iconPrefix: 'far',
			iconActive: 'check-circle',
			iconPrefixActive: 'far'
		},
		{
			title: 'Search by Destination',
			id: 1,
			isActive: false,
			icon: 'circle',
			iconPrefix: 'far',
			iconActive: 'check-circle',
			iconPrefixActive: 'far'
		}
	];



	public testImageGrid: ImageGridItem[];
	public imageGrid: ImageGridItem[]; //todo-jk - i should be able to remove this
	public imageGrid$: Observable<ImageGridItem[]>;

	public infoBoxes1$: Observable<InfoBox[]>;
	public infoBoxes2$: Observable<InfoBox[]>;

	public sliderListFeatured$: Observable<DynamicListDisplay[]>;
	public sliderListPromo$: Observable<DynamicListDisplay[]>;

	public cruiseLines: CruiseLine[];
	public cruiseLines$: Observable<CruiseLine[]>;
	public cruiseLineShipNames$: Observable<string[]>;
	public cruiseLineShipSailDates$: Observable<CruiseLineSailDate[]>;
	public cruiseLineShipSailDates: CruiseLineSailDate[];
	public cartTest: CartTest[];
	//public sliderListFeatured$: Observable<SwiperCardImage[]>;
	// public sliderListPopular$: Observable<SwiperCardImage[]>;
	// public sliderListNature$: Observable<SwiperCardImage[]>;

	public foundDestinations: Destination[];


	public regions$: Observable<Region[]>;
	public regionActive: number = 0;
	public buttonSliderX: number = 0;
	public showButtonSliderPrev: boolean = false;
	public showButtonSliderNext: boolean = false;
	public buttonSlideJumpDistance:number = 100;
	public buttonSlideRightPad:number = 50;
	//public buttonSliderXMin: number = 0;

	public destinations: Destination[];

	public toResize: any;
	public toResizeMs: number = 200;
	//public window: Window = { width: 0, height: 0};

	public minDate = new Date();
	public maxDate = new Date();
	public bsConfig = {
		isAnimated: true,
		containerClass: 'theme-custom',
		showWeekNumbers: false
	}

	public searchModel: string;
	public searchLast: string;

	//public window: Window = { width: 0, height: 0};
	public isMobile: boolean = false;

	@ViewChild("buttonSlider") buttonSlider: ElementRef;
	@ViewChild("buttonSliderWrapper") buttonSliderWrapper: ElementRef;

	constructor(
		private _compassAPICruiseSearchService: CompassAPICruiseSearchService,
		private _compassAPIDestinationsService: CompassAPIDestinationsService,
		private _compassAPIDynamicListService: CompassAPIDynamicListService,
		private _compassAPIRegionsService: CompassAPIRegionsService,
		private _configService: ConfigService,
		private _storageService: StorageService,
		private _metaService: MetaService,
		private _mockAPIProvider: MockAPIProvider,
		private route: ActivatedRoute,
		private router: Router,
		private _utilityService: UtilityService
	) {
		this.minDate = dayjs().subtract(1, 'year').toDate();
		this.maxDate = dayjs().add(3, 'year').toDate();
	}

	ngOnInit(): void {
		//document.title = 'Home';
		//this._configService.doSomething();
		this.getFavorites();
		this.getContent1();

		//this.getRegions();
		this.getDestinations();

	}


	/**
	 * Listen for window resize
	 * @param event
	*/
	@HostListener('window:resize', ['$event'])
	onResize(event:any) {
		//console.log('Resize', event.target.innerWidth, 'x', event.target.innerHeight);
		this.buttonSliderX = 0;
		clearTimeout(this.toResize);
		this.toResize = setTimeout(()=>{
			//this._utilityService.getWindowDims();
			this.isMobile = this._utilityService.getIsMobile();
			this.buttonSlide(1);
		}, this.toResizeMs);
	}


	// /**
	//  * Get window dimensions
	//  * @param event
	// */
	// public getWindowDims(event:any = null) {
	// 	if(event) {
	// 		this.window.width = event.target.innerWidth;
	// 		this.window.height = event.target.innerHeight;
	// 	} else {
	// 		this.window.width = window.innerWidth;
	// 		this.window.height = window.innerHeight;
	// 	}
	// 	//console.log('window:', this.window);
	// 	if(this.window.width < Breakpoint.lg) {
	// 		this.isMobile = true;
	// 	} else {
	// 		this.isMobile = false;
	// 	}

	// }






	public getContent1 () {
		//console.log('getContent1()');
		//'12a0a701-3376-4007-9e3d-41492b28696d'
		this.sliderListFeatured$ = this.getDynamicListDisplay('Home Featured Carousel Section')
			.pipe(map((lists: DynamicListDisplay[]) => {
				if(lists && lists.length > 0) {
					return this._compassAPIDynamicListService.processDataCarousel(lists, 'card', true);
				}
				return null;
			}));

		//014e17dc-e9a9-4b74-8252-d1bcd2602a99
		this.imageGrid$ = this.getDynamicListDisplay('Home Destinations ImageGrid Section')
			.pipe(map((lists: DynamicListDisplay[]) => {
				if(lists && lists.length > 0) {
					return this._compassAPIDynamicListService.processDataImageGrid(lists);
				}
				return null;
			}));

		//'38faf2bf-fc17-4742-a813-7e638185642e'
		this.sliderListPromo$ = this.getDynamicListDisplay('Home Promotional Carousel Section')
			.pipe(map((lists: DynamicListDisplay[]) => {
				if(lists && lists.length > 0) {
					return this._compassAPIDynamicListService.processDataCarousel(lists, 'card', true);
				}
				return null;
			}));


		this.infoBoxes1$ = this._mockAPIProvider.load('main/home-infoboxes-1.json', false)
			.pipe(map((res: InfoBox[]) => {
				if(res && res.length > 0) {
					//console.log('InfoBoxes1:', res);
					return res;
				}
				return null;
			}));

		this.infoBoxes2$ = this._mockAPIProvider.load('main/home-infoboxes-2.json', false)
			.pipe(map((res: InfoBox[]) => {
				if(res && res.length > 0) {
					//console.log('InfoBoxes2:', res);
					return res;
				}
				return null;
			}));



		this.cruiseLines$ = this._compassAPICruiseSearchService.getCruiseLines()
			.pipe(map((data) => {
				//console.log('getCruiseLines.data:', data);
				this.cruiseLines = data;
				return data;
			}));

      this._compassAPICruiseSearchService.cartTest()
			.pipe(map((data) => {
				//console.log('getCruiseLines.data:', data);
				this.cartTest = data;
				return data;
			}));

		// this._mockAPIProvider.load('home-search-dest.json', false)
		// 	.subscribe((data: any[]) => {
		// 		console.log('searchDest::', data);
		// 		this.destinationsData = data;
		// 	});


	}




	/**
	 * get Dynamic List By siteSectionName
	*/
	public getDynamicListDisplay(siteSectionName: string):Observable<DynamicList[]>{
		//console.log('getDynamicListDisplay', siteSectionName);
		return this._compassAPIDynamicListService.getDynamicListDisplay(siteSectionName)
			.pipe(map((data) => {
				//console.log('getDynamicListDisplay.data:', data);
                return data;
			}));

	}


	/**
	 * get Cruise Line Ship Names
	*/
	public getCruiseLineShipNames(){
		//console.log('getCruiseLineShipNames', this.cruiseLineId);
		//if(this.cruiseLineId == '') {
			this.cruiseLineShipName = '';
		//}
		//this.cruiseLineShipSailDate = null;
		this.codeToCruiseId = '';

		this.cruiseLineShipNames$ = this._compassAPICruiseSearchService.getCruiseLineShipNames(this.cruiseLineId)
			.pipe(map((data) => {
				//console.log('getCruiseLineShipNames.data:', data);
				return data;
			}));

	}

	/**
	 * get Cruise Line Ship Sail DAtes
	*/
	public getCruiseLineShipSailDates(){
		//console.log('getCruiseLineShipSailDates', this.cruiseLineId, this.cruiseLineShipName);
		if(this.cruiseLineId == '' || this.cruiseLineShipName == '') {
			//this.cruiseLineShipSailDate = null;
			this.codeToCruiseId = '';
		}

		this.cruiseLineShipSailDates$ = this._compassAPICruiseSearchService.getCruiseLineShipSailDates(this.cruiseLineId, this.cruiseLineShipName)
			.pipe(map((data: CruiseLineSailDate[]) => {
				//console.log('getCruiseLineShipSailDates.data:', data);
				this.cruiseLineShipSailDates = data;
				return data;
			}));

	}


	public gotoItinerary(){
		//console.log('gotoItinerary', this.cruiseLineId, this.cruiseLineShipName, this.codeToCruiseId);

		const cruiseLine = this.cruiseLines.find(item => item.cruiseLineId == this.cruiseLineId),
			cruiseUrl = this._utilityService.makeStringWebsafe(cruiseLine.cruiseLineName) + '/' + this._utilityService.makeStringWebsafe(this.cruiseLineShipName),
			sailDateObj = this.cruiseLineShipSailDates.find(sditem => String(sditem.codeToCruiseId) == this.codeToCruiseId),
			sailDate = dayjs(sailDateObj.sailDate).format('YYYY-MM-DD');

		this.cruiseLineShipSailDate = sailDateObj;
		// console.log('sailDateObj:', sailDateObj);
		// console.log('sailDate:', sailDate);
		// console.log('cruiseLine:', cruiseLine);
		// console.log('cruiseUrl:', cruiseUrl);

		//return;

		this.router.navigate(['/cruises/' + cruiseUrl],  { queryParams: { date: sailDate, codeToCruiseId: sailDateObj.codeToCruiseId}});
	}




	public getRegions () {
		//console.log('getRegions()');
		this.regions$ = this._compassAPIRegionsService.getRegions()
			.pipe(map((res: Region[]) => {
				//console.log('regions:', res);
				if(res && res.length > 0) {
					setTimeout(() => {
						this.buttonSlide(0);
					}, 100);
					return res;
				}
				return null;
			}));
	}


	public loadButtonSlider(index: number){
		//console.log('loadButtonSlider.index:', index);
		this.regionActive = index;

		this.getDestinations();
	}




	public getDestinations() {
		//console.log('getDestinations()');

		let maxInt = 20;
		clearInterval(this.intDest);
		this.intDest = setInterval(() => {
			//console.log('this.testImageGrid:',this.testImageGrid);
			if(this.testImageGrid){
				let list = JSON.parse(JSON.stringify(this.testImageGrid));
				this.imageGrid = list.sort(() => Math.random() - 0.5);
				clearInterval(this.intDest);
			}
			maxInt --;
			if(maxInt == 0) {
				clearInterval(this.intDest);
			}
		}, 1000);


	}




	public buttonSlide(dir:number){

		if(!this.buttonSliderWrapper) return;

		const buttonSliderWrapperRect = this.buttonSliderWrapper.nativeElement.getBoundingClientRect(),
			buttonSliderRect = this.buttonSlider.nativeElement.getBoundingClientRect(),
			relativePosLeft = buttonSliderRect.left - buttonSliderWrapperRect.left,
			newX = (dir * this.buttonSlideJumpDistance) + relativePosLeft,
			minX = 0 - buttonSliderRect.width + buttonSliderWrapperRect.width - this.buttonSlideRightPad,
			maxX = 0,
			isWider = buttonSliderRect.width > buttonSliderWrapperRect.width;

		if(newX > maxX || !isWider) {
			this.buttonSliderX = maxX;
		} else if (newX < minX  ) {
			this.buttonSliderX = minX;
		} else {
			this.buttonSliderX = newX;
		}


		if(isWider && this.buttonSliderX != maxX) {
			this.showButtonSliderPrev = true;
		} else {
			this.showButtonSliderPrev = false;
		}
		if(isWider && this.buttonSliderX != minX) {
			this.showButtonSliderNext = true;
		} else {
			this.showButtonSliderNext = false;
		}


		// console.group('buttonSlide()');
		// console.log("dir:", dir);
		// console.log("buttonSliderWrapperRect:", buttonSliderWrapperRect);
		// console.log("buttonSliderRect:", buttonSliderRect);
		// console.log("relativePosLeft:", relativePosLeft);
		// console.log("minX:", minX);
		// console.log("newX:", newX);
		// console.log("buttonSliderX:", this.buttonSliderX);
		// console.groupEnd();

	}




	/**
	 * Get sectionActive from child component
	 * @param active
	 */
	public getChildSectionActive(active: any): void{
		//console.log('getChildSectionActive: ', active);
		const activeArr = String(active).split('-');
		this.sectionActive = active;
	}




	/**
	 * Get favorites array
	*/
	public getFavorites(){
		this.favsList = this._storageService.getFavorites();
		//console.log('getFavorites().favsList:', this.favsList);
	}

	/**
	 * Set favorites array
	*/
	public setFavorites(){
		//this.favsList = ['222'];
		//console.log('setFavorites: ', this.favsList);
		this._storageService.setFavorites(this.favsList);
		//TODO-JK: SEND CALL TO API TO UPDATE
	}

	/**
	 * Check swipers against favs
	 * @param items
	*/
	public checkSwiperFavs(items: SwiperCardImage[]) {
		items.forEach(item => {
			const isFavorite = this.favsList.includes(item.id);
			//console.log('checkFavs.item.id:', item.id, isFavorite);
			item.isFavorite = isFavorite;
		});
	}

	/**
	 * ToggleFavorite initiates from child component
	 * then check array for ID. if not found, add to list, else remove
	 * then push to storage
	 * @param slide
	*/
	public toggleFavorite(slide: SwiperCardImage): void{
		const isFavorite = this.favsList.includes(slide.id);
		//console.log('toggleFavorite.slide:', slide.id, isFavorite);
		slide.isFavorite = !isFavorite;//TOGGLE

		if(slide.isFavorite) {
			if(!this.favsList) this.favsList = [];
			this.favsList.push(slide.id);
		} else {
			const pos = this.favsList.indexOf(slide.id);
			//console.log('pos:', pos);
			this.favsList.splice(pos, 1)
		}
		this.setFavorites();

	}

	// /**
	//  * addToBoard initiates from child component
	//  *
	//  * @param slide
	// */
	// public addToBoard(slide: SwiperCardImage) {
	// 	console.log('addToBoard.slide:', slide);
	// }






	// /**
	//  * Toggle infobox open/closed, close others
	//  * @param box
	//  */
	// public toggleInfoBox(box:any){
	// 	this.infoBar.children.forEach(child => {
	// 		//console.log('box:', box, 'vs', child);

	// 		if(box == child) {
	// 			//console.log('found match ^^');
	// 			child.isActive = !child.isActive;
	// 		} else {
	// 			if(child.isActive) child.isActive = false;
	// 		}
	// 	});
	// }




	/**
	 * Use this to keep the serach_model updated. was not recognizing full search term otherwise.
	 * @param evt
	*/
	public onChangeSearch(evt) {
		//console.log('onChangeSearch:', evt);

		if (this.searchLast != evt) {
			//this.setSearchParams(null, null);//clear out
			this.searchModel = evt;
			this.searchLast = evt;
			//console.log('searchModel:', this.searchModel);
			if (this.searchModel.length >= 2) {
				this.searchDestinations();
			} else {
				this.foundDestinations = null;
			}
		}
	}





	/**
	 * Search destinations
	 * @param search
	*/
	public searchDestinations(){
		if(!this.searchModel) return;

		//console.log('searchDestinations()');

		this.foundDestinations = null;
		const search: string = this.searchModel;

		this._compassAPIDestinationsService.getDestinations(search, 10)
			.subscribe((res: Destination[]) => {
				//console.log('foundDestinations::', res);
				this.foundDestinations = res;
			});

	}


	// public goToSearchPage(){
	// 	alert('go to search page and look for: ' + this.searchModel);
	// }


	// /**
	//  * Filter Destinations
	//  * @param search
	//  */
	// public filterDestinations(search: string){
	// 	console.log('filterDestinations:', search);

	// 	let foundDestinations: any[] = [];

	// 	foundDestinations = this.destinationsData.filter((dest) => {
	// 		const isLike = dest.title.toUpperCase() == search.toUpperCase() || (dest.title.toUpperCase()).indexOf(search.toUpperCase()) != -1;
	// 		return isLike;
	// 	});

	// 	this.foundDestinations = foundDestinations;

	// }

}
